import { useTranslation } from 'react-i18next';
import { type InsuranceModuleSpecsFragment } from '../../../../../api/fragments/InsuranceModuleSpecs';
import {
    type CreateInsuranceModuleMutation,
    CreateInsuranceModuleDocument,
    type CreateInsuranceModuleMutationVariables,
} from '../../../../../api/mutations/createInsuranceModule';
import { type InsuranceModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import InsuranceModulePage, { type InsuranceModulePageProps } from '../../InsuranceModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<InsuranceModuleSpecsFragment, InsuranceModuleSettings> = {
    PageComponent: ({ module }: InsuranceModulePageProps) => <InsuranceModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.InsuranceModule.className'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    getValidator: () => validators.compose(validators.requiredNonEmptyString('displayName')),
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateInsuranceModuleMutation, CreateInsuranceModuleMutationVariables>({
                mutation: CreateInsuranceModuleDocument,
                variables: { companyId, settings: values },
            })
            .then(({ data }) => data.module),
};

export default implementation;
